import React from 'react'
import { Switch, Route } from 'react-router-dom';
import Cookies from 'cookies-js';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import PropTypes from 'prop-types';
import { logoutPath, invalidTokenPath } from '../Services/config/apiGateway';
import '../App.css'
import '../css/shared/SessionModal.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import SessionExpire from '../components/shared/SessionExpire';
import Header from '../components/shared/Header';
import Footer from '../components/shared/Footer';
import Dashboard from '../components/pages/home/Home';
import CreateRole from '../components/pages/createRole/RoleManagement';
import AssignRole from '../components/pages/assignRole/AssignRole';
import Announcement from '../components/pages/announcement/Announcement';
import Advertisement from '../components/pages/advertisement/Advertisement';
import UserProfile from '../components/pages/userProfileApproval/UserProfile';
import OpenList from '../components/pages/userProfileApproval/OpenItem';
import SubscriptionFees from '../components/pages/subscriptionFees/SubscriptionFees';
import SysyemConfig from '../components/pages/systemConfig/SystemConfig';
import PreAdvise from '../components/pages/preAdvise/PreAdvise';
import MaintainFacility from '../components/pages/systemConfig/MaintainFacility';
import MaintainFunction from '../components/pages/systemConfig/MaintainFunction';
import MaintainLookup from '../components/pages/systemConfig/MaintainLookup';
import TermsConditions from '../components/pages/termsConditions/TermsConditions';
import TransactionFees from '../components/pages/TransactionFees/TransactionFees';
import TransactionFeesDiscount from '../components/pages/transaction/TransactionFeesDiscount';
import ServiceType from '../components/pages/TransactionFees/ServiceType';
import ManageServices from '../components/pages/manageServices/ManageServices';
import CancellationPolicy from '../components/pages/cancellationPolicy/CancellationPloicy';
import NotFound from './NotFound';
import { ApmRoute } from '@elastic/apm-rum-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
var interval = null;
class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      timeout: 1000 * 120 * 1,
      showModal: false,
      userLoggedIn: false,
      isTimedOut: false,
      seconds: 0,
      changeSecondsColor: false,
      pageFound: true,
      createRole: '',
      assignRole: '',
      advertisement: '',
      announcement: '',
      userProfile: '',
      openList: '',
      subscriptionFee: '',
      systemConfig: '',
      maintainFacility: '',
      maintainFunction: '',
      maintainLookup: '',
      preAdvice: '',
      termsAndConditions: '',
      transactionFees: '',
      serviceType: '',
      transactionDiscount: '',
      manageService: '',
      cancellationPolicy: '',
    }
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
  }
  _onAction(e) {
    this.setState({ isTimedOut: false })
  }
  _onActive(e) {
    console.log('user is active', e)
    this.setState({ isTimedOut: false })
  }
  _onIdle(e) {
    console.log('user is idle', e)
    const isTimedOut = this.state.isTimedOut
    if (isTimedOut) {
      Cookies.expire('msAL_admin_dev');
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace(logoutPath)
    } else {
      // open modal and set Time
      let testAccess = Cookies.get('msAL_admin_dev');
      testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
      this.setState({ showModal: true, seconds: 60 });
      // start timer
      clearInterval(interval);
      interval = setInterval(() => {
        if (this.state.seconds > 0) {
          this.setState({ changeSecondsColor: false, seconds: this.state.seconds - 1 }
            , () => {
              // for change seconds color
              if (this.state.seconds < 10) {
                this.setState({ changeSecondsColor: true });
              }
              // for autometic logout
              if (this.state.seconds === 0 && this.state.showModal) {
                fetch(invalidTokenPath, {
                  method: 'GET',
                  headers: {
                    'Authorization': 'Bearer ' + testAccess,
                    'refresh_token': Cookies.get('msAL_adminRef_dev')
                  }
                })
                  .then(res => {
                    return res;
                  })
                  .then(data => {
                    Cookies.expire('msAL_admin_dev');
                    Cookies.expire('msAL_adminRef_dev');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace(logoutPath)
                  });
              }
            }
          );

        }
        else {
          clearInterval(interval);
        }
      }, 1000);
      return () => { clearInterval(interval) }
    }
  }

  handleLogout() {
    this.setState({ showModal: false })
    let testAccess = Cookies.get('msAL_admin_dev');
    testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
    fetch(invalidTokenPath, {
      // fetch(`https://tpt-apim-cargo-dev.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens`, {
      // fetch(`https://tpt-apim-cargo-test.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens`, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + testAccess,
        'refresh_token': Cookies.get('msAL_adminRef_dev')
      }
    })
      .then(res => {
        return res;
      })
      .then(data => {
        Cookies.expire('msAL_admin_dev');
        Cookies.expire('msAL_adminRef_dev');
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace(logoutPath)
        // window.location.replace('https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.dev-cargoconnectadmin.transnetportterminals.net')
        // window.location.replace('https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.test-cargoconnectadmin.transnetportterminals.net')
      });
  }
  onCloseModal() {
    console.log("in close modal");
    this.setState({ timeout: 1000 * 120 * 1 });
    this.setState({ showModal: false });
    this.setState({ changeSecondsColor: false });
  }
  componentWillReceiveProps = () => {
    var selectedTiles = [];
    let roleData = this.props.roleData
    if (roleData !== undefined) {
      // working
      for (let z = 0; z < roleData.length; z++) {
        var rd = roleData[z].permissions;
        selectedTiles.push(rd)
      }
      selectedTiles.map(x =>
        x.map(md => {
          switch (md.functionId) {
            case 13:
              return this.setState({
                createRole: <Route path="/Role" component={CreateRole} />
              });
            case 12:
              return this.setState({
                assignRole: <Route path="/AssignRole" component={AssignRole} />
              });
            case 15:
              return this.setState({
                advertisement: <Route path="/Advertisement" component={Advertisement} />
              });
            case 22:
              return this.setState({
                announcement: <Route path="/Announcement" component={Announcement} />
              });
            case 14:
              return this.setState({
                userProfile: <Route path="/UserProfile" component={UserProfile} />,
                openList: <Route path="/OpenItem" component={OpenList} />
              });
            case 19:
              return this.setState({
                subscriptionFee: <Route path="/SubscriptionFees" component={SubscriptionFees} />
              });
            case 1:
              return this.setState({
                systemConfig: <Route path="/SystemConfig" component={SysyemConfig} />,
                maintainFacility: <Route path="/MaintainFacility" component={MaintainFacility} />,
                maintainFunction: <Route path="/MaintainFunction" component={MaintainFunction} />,
                maintainLookup: <Route path="/MaintainLookup" component={MaintainLookup} />
              });
            case 11:
              return this.setState({
                preAdvice: <Route path="/PreAdvice" component={PreAdvise} />
              });
            case 16:
              return this.setState({
                termsAndConditions: <Route path="/TermConditions" component={TermsConditions} />
              });
            case 18:
              return this.setState({
                transactionFees: <Route path="/TransactionFees" component={TransactionFees} />,
                serviceType: <Route path="/ServiceType" component={ServiceType} />
              });
            case 17:
              return this.setState({
                transactionDiscount: <Route path="/TransactionFeesDiscount" component={TransactionFeesDiscount} />
              });
            case 27:
              return this.setState({
                manageService: <Route path="/ManageServices" component={ManageServices} />
              })
            case 24:
              return this.setState({
                cancellationPolicy: <Route path="/CancellationPolicy" component={CancellationPolicy} />
              })
            default:
              break;
          }
        }
        ))
    }
  }
  componentDidMount = () => {
    var selectedTiles = [];
    let roleData = this.props.roleData
    if (roleData !== undefined) {
      // working
      for (let z = 0; z < roleData.length; z++) {
        var rd = roleData[z].permissions;
        selectedTiles.push(rd)
      }
      selectedTiles.map(x =>
        x.map(md => {
          console.log(md.functionId)
          switch (md.functionId) {
            case 13:
              return this.setState({
                createRole: <Route path="/Role" component={CreateRole} />
              });
            case 12:
              return this.setState({
                assignRole: <Route path="/AssignRole" component={AssignRole} />
              });
            case 15:
              return this.setState({
                advertisement: <Route path="/Advertisement" component={Advertisement} />
              })
            case 22:
              return this.setState({
                announcement: <Route path="/Announcement" component={Announcement} />
              });
            case 14:
              return this.setState({
                userProfile: <Route path="/UserProfile" component={UserProfile} />,
                openList: <Route path="/OpenItem" component={OpenList} />
              });
            case 19:
              return this.setState({
                subscriptionFee: <Route path="/SubscriptionFees" component={SubscriptionFees} />
              });
            case 1:
              return this.setState({
                systemConfig: <Route path="/SystemConfig" component={SysyemConfig} />,
                maintainFacility: <Route path="/MaintainFacility" component={MaintainFacility} />,
                maintainFunction: <Route path="/MaintainFunction" component={MaintainFunction} />,
                maintainLookup: <Route path="/MaintainLookup" component={MaintainLookup} />
              });
            case 11:
              return this.setState({
                preAdvice: <Route path="/PreAdvice" component={PreAdvise} />
              });
            case 16:
              return this.setState({
                termsAndConditions: <Route path="/TermConditions" component={TermsConditions} />
              });
            case 18:
              return this.setState({
                transactionFees: <Route path="/TransactionFees" component={TransactionFees} />,
                serviceType: <Route path="/ServiceType" component={ServiceType} />
              });
            case 17:
              return this.setState({
                transactionDiscount: <Route path="/TransactionFeesDiscount" component={TransactionFeesDiscount} />
              });
            case 27:
              return this.setState({
                manageService: <Route path="/ManageServices" component={ManageServices} />
              })
            case 24:
              return this.setState({
                cancellationPolicy: <Route path="/CancellationPolicy" component={CancellationPolicy} />
              })
            default:
              break;
          }
        }
        ))
    }
  }

  render() {
    return (
      <>
        <Header />
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={this.state.timeout}
        />
        <Switch>
          <ApmRoute
            exact
            path="/"
            component={() => (
              <Dashboard
                to=
                {{
                  pathname: '/home'
                }}
              />
            )}
          />
          {this.state.createRole}
          {this.state.assignRole}
          {this.state.advertisement}
          {this.state.announcement}
          {this.state.userProfile}
          {this.state.openList}
          {this.state.subscriptionFee}
          {this.state.systemConfig}
          {this.state.maintainFacility}
          {this.state.maintainFunction}
          {this.state.maintainLookup}
          {this.state.preAdvice}
          {this.state.termsAndConditions}
          {this.state.transactionFees}
          {this.state.serviceType}
          {this.state.transactionDiscount}
          {this.state.manageService}
          {this.state.cancellationPolicy}
          {/* <Route path="/Role" component={CreateRole} />
          <Route path="/AssignRole" component={AssignRole} />
          <Route path="/Advertisement" component={Advertisement} />
          <Route path="/Announcement" component={Announcement} />
          <Route path="/UserProfile" component={UserProfile} />
          <Route path="/SubscriptionFees" component={SubscriptionFees} />
          <Route path="/OpenItem" component={OpenList} />
          <Route path="/ClosedItem/:userId/:roleId/:comments/:approvalStatus" component={ClosedList} />
          <Route path="/SystemConfig" component={SysyemConfig} />
          <Route path="/PreAdvice" component={PreAdvise} />
          <Route path="/MaintainFacility" component={MaintainFacility} />
          <Route path="/MaintainFunction" component={MaintainFunction} />
          <Route path="/MaintainLookup" component={MaintainLookup} />
          <Route path="/TermConditions" component={TermsConditions} />
          <Route path="/TransactionFees" component={TransactionFees} />
          <Route path="/TransactionFeesDiscount" component={TransactionFeesDiscount} />
          <Route path="/ServiceType" component={ServiceType} />
          <Route path="/ManageServices" component={ManageServices} />
          <Route path="/CancellationPolicy" component={CancellationPolicy} /> */}
          <Route component={NotFound} ></Route>
        </Switch>
        <Footer />
        <SessionExpire hasOpen={this.state.showModal} onCloseModal={this.onCloseModal} onYesModal={this.handleLogout}>
          <div>
            <div class="AccepttermscondiDivout" className="sessionExpireContentInnerDiv">
              <small class="sessionExpireContentText"> Your session is about to expire.</small>
              <div class="sessionExpireTimerDiv">
                <small class="sessionExpireTimerContent">You will be logged out in
                    <small class={this.state.changeSecondsColor ? "sessionExpireTimerTextOrange" : "sessionExpireTimerTextBlack"}> {this.state.seconds} </small>
                  seconds.
                  </small>
              </div>
            </div>
          </div>
        </SessionExpire>
      </>
    )
  }
}
Layout.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.func.isRequired
}
function mapStateToProps(state) {
  if (state.authentication.user) {
    return {
      data: JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
      roleData: state.adminRoleReducer.roleData,
    }
  }
}
export default connect(mapStateToProps)(Layout);